import styled from '@emotion/styled';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })`
`;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })`
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
`;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    span {
        display: block;
    }
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
`;
